import { getValidUrl } from './getValidUrl';
export const handleAnswerClick = (e, goTo, answer, historyAnswer = '') => {
	if (e) e.stopPropagation();
	if (!answer.external && answer.sceneId) {
		goTo(answer.sceneId, historyAnswer);
	} else if (answer.external && answer.url) {
		const target = answer.newTab ? '_blank' : '_self';
		window.open(getValidUrl(answer.url), target);
	}
}